import Client from './Clients/AxiosClient'
const resource = 'ship_to_home_shipping_prices'

export default {
  get ({typeBook, pageCount, year, typeSize}) {
    let fs = year ? `year=${year}` : ''
    fs = typeBook ? `${fs}&type_book=${typeBook}` : fs
    fs = pageCount ? `${fs}&page_count=${pageCount}` : fs
    fs = typeSize ? `${fs}&type_size=${typeSize}` : fs
    return Client.get(`${resource}?${fs}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  }
}
